import type { HTMLAttributes } from "react";

// Card / frame surface. `flush` drops the inner padding (for edge-to-edge
// content like a table). Backs .card in components.css.
export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  flush?: boolean;
  as?: "div" | "section" | "article" | "aside";
}

export function Card({ flush, as: Tag = "div", className, ...rest }: CardProps) {
  const classes = ["card", flush ? "card--flush" : "", className].filter(Boolean).join(" ");
  return <Tag className={classes} {...rest} />;
}
